import { myTeachersRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.ASSISTANT];

const myTeachersRouteMetadata: IRouteMetadataObj<typeof myTeachersRoutesObj> = {
  list: {
    title: "myTeachers.index.title",
    description: "myTeachers.index.description",
    lazy: () => import("@/pages/teacherList/table/page"),
    mode: "index",
    type: "main",
    icon: "UserVoiceLine",
    breadcrumbs: [],
    permission,
  },
};

export const myTeachersRoutes = createRoute<typeof myTeachersRoutesObj>(
  myTeachersRoutesObj,
  myTeachersRouteMetadata,
);
